export default __webpack_public_path__ + "static/media/powerutil3.68c38b81.svg";